<template>
  <div id='buyPlan' >
      <div class="page-mask" @click="closeSelect"   v-if='selectShow'></div>
      
         <div class="buyPlanBox"   :class="selectShow?'outShow':''" >
              <div class="buyPlanclose" @click="closeSelect" >
                  <img src="../assets/icon-delete.png"  />
              </div>
            
              <div class="buyPlanselect">
              <div></div>
                  <div class="title">请选择购买方案</div>
                  <div class="items" >
                      <div v-for='(item,index) in buyType'>
                         <div class="item"  :class="item.pick?'active':''"    data-index='index' @click='handleBuyType(index)' >
                              <div class='itemTitle'>{{item.title}}</div>
                              <div class='itemPrice'>
                                    <span v-if='item.productsMoney!=item.payMoney'>¥{{item.productsMoney}}</span>¥{{item.payMoney}}
                              </div>
                         </div>
                      </div>
                  </div>
              </div>
              <div class="btns">
                 <div class="page-buy" v-if='buyPlanId == 0' style='background:#C0BFC1' bindtap='notopay'>确认方案</div>
                  <div class="page-buy"  @click="toCreateOrder" v-else >确认方案</div>
              </div>
          </div>
        
  </div>
</template>

<script>
  

    
export default {
  name: 'buyPlan',
  props: {
	// comeform: {      //选择方案来源     1报告赠送   2套餐等不弹出方案选择页   3再买一单    4购物车来(修改购买方案)   5套餐再买一单   6报告加入购物车    7报告直接购买
	//      type: String,
	//    },
  },
  
 
  data:function(){
    return{
     buyPlanShow:true,
	 selectShow:false,        //Boolean类型，弹出选择
	 buyType:[],
	 buyPlanId:0,
    }
  },
  created:function(){
	
      this.getBuyPlan()
   },
  mounted:function() {
	
  
  },
  methods: {
	   // 获取全部购买方案
	  getBuyPlan() {
		let that = this
		this.axios({
			method: 'post',
			url:"cart/getBuyPlan",
			data:{
			   member_id:this.$store.state.member_id
			},
		}).then(res=>{
		  res.data.data[0].pick = true
		
			that.buyType= res.data.data
			that.buyActive= res.data.data[0]
			that.buyPlanId=res.data.data[0].id
			that.buyImg= res.data.data[0].thumb_url
		  
		})
	  },
	// 获取订单商品信息
	getOrderDetail(orderid,comeform){
		let that =this
		this.comeform= comeform
	},
	// 获取橘袋商品信息
	getCartDetail(cartid,comeform){
		let that =this
		this.comeform= comeform
		this.cartid = cartid
		this.axios({
		            method: 'post',
		            url:"Allcart/getCartOne",
		            data:{
						cart_id:cartid
		            }
					}).then(res=>{
						res.data.cart.goods_info.forEach((item)=>{
							item.day_use =item.goods_num
							item.shop_price =item.goods_price
						})
						let _buyType = that.buyType
						_buyType.forEach((item)=>{
							item.pick = false
							if(item.id==res.data.cart.buy_id){
								item.pick = true
								that.buyActive= item
								that.buyPlanId=item.id
								that.buyImg= item.thumb_url
							}
						})
						that.buyType= _buyType
						
						that.products = res.data.cart.goods_info
					
						that.computeGoods()
					})
	},
	// 获取套餐商品信息
	getMealDetail(mealid,comeform){
		let that =this
		this.comeform= comeform
	},
	//获取报告商品信息
	getCountDetail(countid,comeform){
		let that =this
		this.comeform= comeform
		this.axios({
		            method: 'post',
		            url:"index/getCountInfo",
		            data:{
		               member_id:this.$store.state.member_id,
						count_id:countid
		            }
					}).then(res=>{
						// res.data.goods_list.forEach((item)=>{
						// 	item.day_use =item.goods_num
						// 	item.shop_price =item.goods_price
						// })
						that.products = res.data.goods_list
						that.countid = countid
						that.computeGoods()
					})
	},
// 计算商品信息
    computeGoods: function () {
      console.log("计算商品信息")
      let _products = this.products   //产品信息
      let _buyType = this.buyType    //购买方案信息

      let _stockNull = false    //是否缺货
      let _stockNullName = ''   //缺货商品名
      let _productsMoney   //商品总价
      let _payMoney        //优惠后产品价格

      if (_products.length < 1) return
     

      for (let i = 0; i < _buyType.length; i++) {
          _payMoney = 0
          _productsMoney = 0
          _products.forEach((item, index) => {
            item.goods_num = item.day_use
            item.goods_price = item.shop_price
              _productsMoney += Number(item.shop_price * item.day_use)
              if (Number(item.day_use) * Number(_buyType[i].days) > item.goods_stock) {
                _stockNullName = item.goods_name
              }
              if (item.status == 0) {
                _stockNull = true
                _stockNullName = item.goods_name
              }  
          })
        _payMoney = Number((_productsMoney * Number(_buyType[i].discount) * Number(_buyType[i].days)).toFixed(2))
        _productsMoney = Number((_productsMoney * Number(_buyType[i].days)).toFixed(2))
        _buyType[i].productsMoney = _productsMoney
        _buyType[i].payMoney = _payMoney
		this.$set(this.buyType , i , _buyType[i])
      }
        this.stockNull= _stockNull
        this.stockNullName= _stockNullName
		this.selectShow = true
    },
	
	// 选择购买方案
	handleBuyType(e) {
	console.log(e)
	  let _buyType = this.buyType
	  let _buyPlanId = 1
	  let _buyImg = ""
	  let _buyActive = _buyType[0]
	  _buyType.forEach((item, index) => {
		item.pick = false
		if (e == index) {
		  item.pick = true
		  _buyPlanId = item.id
		  _buyActive = item
		  _buyImg = item.thumb_url
		}
		this.$set(this.buyType , index , _buyType[index])
	  })
		this.buyPlanId= _buyPlanId
		this.buyActive= _buyActive
		this.buyImg=_buyImg
	},
	// 确认方案
	toCreateOrder: function (){
			
		      let _options = {}
		      let _comeform = this.comeform.toString()
			  
		      //方案来源   1报告赠送   2套餐等不弹出方案选择页   3再买一单    4购物车来(修改购买方案)   5套餐再买一单   6报告加入购物车  7橘袋详情(购物车id)直接购买
			
		      switch (_comeform) {
		        case "1":     //报告赠送
		          _options = {
		            member_id: this.$store.state.member_id,
		            source: 3,                  //source购买来源:        0:自选，1:报告,2:套餐,3送礼
		            buy_id: this.buyPlanId,                  //购买方案id
		            count_id: this.countid,                  //报告id
		          }
		          this.addCart(_options)
		          break;
		        case "2":    //套餐等不弹出方案选择页
		          _options = {
		            member_id: this.$store.state.member_id,
		            source: 2,                  //source购买来源:        0:自选，1:报告,2:套餐,3送礼
		            meal_id: this.mealid,                                   //套餐id
		          }
		          this.addCart(_options)
		          break;
		        case "3":    //再买一单
		          break;
		
		        case "4":    //购物车来(修改购买方案)
		          _options = {
		            cart_id: this.cartid,                    //橘袋id
		            buy_id: this.buyPlanId,                  //购买方案id
		          }
		          this.updateBuyPlan(_options)
		          break;
		
		        case "5":    //套餐再买一单 
		          break;
		        case "6":    //报告加入购物车
		          _options = {
		            member_id: this.$store.state.member_id,
		            source: 1,                  //source购买来源:       0:自选，1:报告,2:套餐,3送礼
		            buy_id: this.buyPlanId,                 //购买方案id
		            count_id: this.countid,                 //报告id
		          }
				
		          this.addCart(_options)
		          break;
		        case "7":    //报告直接购买
		            _options = {
		             member_id: this.$store.state.member_id,
		             source: 1,                  //source购买来源:       0:自选，1:报告,2:套餐,3送礼
		             buy_id: this.buyPlanId,                 //购买方案id
		             count_id: this.countid,
		            }
		          this.reportBuy(_options)
		
		          break;
		      }
		    },
	//添加产品，套餐，报告到新橘袋(创建新购物车)
	addCart: function (options){
	  let that = this
	  this.axios({
	              method: 'post',
	              url:'Allcart/addCart',
	              data:options
	  			}).then(res=>{
					that.$parent.getCartList()
					that.nullBuyPlan()
					// if (options.source == 3) {
					// 	this.$router.push({name: 'cart'})
					 
					// } else {
					//  this.$router.push({name: 'cart'})
					  
						
					// that.nullBuyPlan()
					// }
				})
	  
		   },
	// 报告直接购买
	reportBuy(options){
		let that = this
		this.axios({
		            method: 'post',
		            url:'Allcart/addCart',
		            data:options
					}).then(res=>{
							that.nullBuyPlan()
							let _cartid = res.data.cart_id
							 that.$router.push({
								name: 'orderMade',
								params: { "cartids":[_cartid]}
							})
						})
	},
		// 更新橘袋购买方案
	    updateBuyPlan: function (options){
	       let that = this
			this.axios({
		              method: 'post',
		              url:'Allcart/updateBuyPlan',
		              data:options
			}).then(res=>{
					that.$parent.updateCartList(options.cart_id, that.buyActive.payMoney, that.buyActive.days, that.buyActive.title, that.buyActive.productsMoney, that.buyActive.url)
					that.nullBuyPlan()
			})
	      
	    },
		// 置空选择方案组件数据
		nullBuyPlan:function(){
			this.selectShow= false
			this.products= []
			this.orderid= ""
			this.stockNull= true
			this.cartid= 0
			this.mealid=0

		},
		 // 关闭选择
		closeSelect:function(){
			console.log("关闭选择")
			this.nullBuyPlan()
			
		},
		// 修改橘袋数量
		editCartNum: function (id, num) {
			let that = this
			return new Promise(function (resolve, reject) {
		      num = Number(num)
		      if (num < 1) {
		        num = 1
		      }
		      if (num > 99) {
		        num = 99
		      }
			that.axios({
			            method: 'post',
			            url:'Allcart/editCartNum',
			            data:{ cart_id: id, num: num }
			}).then(res=>{
					resolve(res)
			      },ref=>{
			        reject(ref)
			})
		     
			})
		},
  }
}
</script>  

<style>
#buyPlan{
	
}
.page-mask{
  position: fixed;
  z-index: 110;
  width: 7.5rem;
  height: 100vh;
  top: 0;
  left:50%;
  transform: translate(-50%,0); 
  background: rgba(0, 0, 0, 0.5);

}
.page-buy{
  box-shadow: 0px 16px 25px -5px rgba(209, 102, 89, 0.2);
  position: relative;
  background-color: #C25E4D;
  color: #fff;
  border-radius: 1rem;
  display: inline-block;
  width: 4.15rem;
  line-height: 0.88rem;
  font-size: 0.3rem;
  overflow: visible;
  font-weight: 500;
  margin: 0;
  text-align: center;
  letter-spacing: 0.005rem;
  z-index: 110;
}
.buyPlanBox {
	width: 7.5rem;
    min-height: 6rem;
    background: #fff;
    position: fixed;
    bottom: -8rem;
	left:50%;
    transform: translate(-50%,0);
    padding:0.3rem 0.03rem;
    z-index: 111;
    transition: all .3s;
}
.outShow{
  bottom: 0;
}
.buyPlanBox .buyPlanclose {
    position: absolute;
    right: 0.4rem;
    top: 0.4rem;
    z-index: 90;
}
.buyPlanBox .buyPlanclose img {
    width: 0.25rem;
    height: 0.25rem;
}

.buyPlanBox .buyPlanselect {
    width: 7.1rem;
    box-sizing: border-box;
    padding: 0 0.2rem;
}
.buyPlanBox .buyPlanselect .title {
    font-size:0.32rem;
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight:600;
    color:rgba(20,20,20,1);
    line-height:0.48rem;
    margin-bottom: 0.4rem;
}
.buyPlanBox .buyPlanselect .items {
    max-height: 4rem;
}
.buyPlanBox .buyPlanselect .item {
    background: #fff;
    border-radius: 0.05rem;
    font-size: 0.24rem;
    margin: 0.2rem auto;
    display: flex;
    box-sizing: border-box;
    height: 0.88rem;
    width:5.6rem;
    border:1px solid rgba(216,216,216,1);
    line-height:0.88rem;
    justify-content: space-between;
    padding: 0 0.2rem;
    overflow: hidden;
}

.itemTitle{
  font-size:0.32rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(20,20,20,1);
  letter-spacing:0.02rem;
}
.buyPlanBox .buyPlanselect  .item.active {
  border:0.02rem solid rgba(194,94,77,1);
}
.buyPlanBox .buyPlanselect .tip {
    color: #999;
}
.buyPlanBox .btns {
    padding: 0.5rem 0 0.2rem 0;
    text-align: center;
}
.nullpick{
   background:  #ddd  !important;
   border: 1px solid #ddd  !important;
   color: #fff !important;
}

.itemPrice{
  font-size:0.28rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(194,94,77,1);
  letter-spacing:0.01rem;
}
.itemPrice span{
  text-decoration:line-through;
  font-size:0.26rem;
  font-weight:400;
  color:rgba(142,142,142,1);
  margin-right: 0.2rem;
}
</style>